import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=077dd00c&scoped=true"
import script from "./OrderTemplate.vue?vue&type=script&lang=js"
export * from "./OrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./OrderTemplate.vue?vue&type=style&index=0&id=077dd00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dd00c",
  null
  
)

export default component.exports